import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';

const Actions = ({ onDelete, row }) => {
	const handleDelete = () => onDelete(row);

	return (
		<Stack direction="row" spacing={1} justifyContent="flex-end">
			<IconButton onClick={handleDelete}>
				<DeleteIcon />
			</IconButton>
		</Stack>
	);
};

export default Actions;
